import Mock from 'mockjs';
import loginAPI from './login';
import registerAPI from './register'
import homeAPI from './home'
import forgetAPI from './forget'
import agreementAPI from './agreement'
import rechargeAPI from './recharge'
import exchangeAPI from './exchange'

// 登录相关
// Mock.mock(/\/login\/loginbyaccount/, 'post', loginAPI.loginByAccount);
Mock.mock(/\/login\/logout/, 'post', loginAPI.logout);
//Mock.mock(/\/user\/info\.*/, 'get', loginAPI.getInfo)

//注册相关
//Mock.mock(/\/register\/registerbyaccount/, 'post', registerAPI.registerByAccount);

//获取游戏列表数据
Mock.mock(/\/home\/getgamelist/, 'get', homeAPI.getGameList)

//找回密码
Mock.mock(/\/forget\/getbackpassword/, 'post', forgetAPI.getBackPassword)

//验证码

Mock.mock(/\/getcheckcode/, 'post', {"code":0, "data": {"checkcode":4515}, "message": "success"})

//绑定邮箱
Mock.mock(/\/bindemail/, 'post', {"code":0, "data": "", "message": "success"})

//获取用户协议
Mock.mock(/\/agreement/, 'post', agreementAPI.getArticle)

//获取充值方式
Mock.mock(/\/recharge\/getpayway/, 'post', rechargeAPI.getPayWay)

//获取充值套餐
Mock.mock(/\/recharge\/getpaymeal/, 'post', rechargeAPI.getPayMeal)

//获取游戏列表
Mock.mock(/\/exchange\/getgamelist/, 'post', exchangeAPI.getGameList)
//获取服务器列表
Mock.mock(/\/exchange\/getservicelist/, 'post', exchangeAPI.getServiceList)
//获y游戏角色列表
Mock.mock(/\/exchange\/getrolelist/, 'post', exchangeAPI.getRoleList)

export default Mock;



// WEBPACK FOOTER //
// ./src/mock/index.js